import React, { Fragment, useState, useCallback } from 'react';
import './ChatMsg.css';
import clientIcon from '../../../../assets/clientIcon.png';
import userIcon from '../../../../assets/userIcon.png';
import DOMPurify from 'dompurify';
import { useTranslation } from "react-i18next";
import { deleteMsgById, UpdateMsgById, patchMsgById } from '../../../../axios/requests/msgReq'
// import * as fileReq from '../../../../axios/requests/filesReq'
import { removeSpecialChars } from '../../../../util/functions';
import ChatMsgFile from './ChatMsgFile';

const domPurifyOptionsObj = {
    ALLOWED_TAGS: ['b', 'i', 'u', 's', 'br', 'p', 'div', 'ul', 'ol', 'li', 'a', 'img', 'blockquote', 'code'],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'style'],
    ALLOW_DATA_ATTR: false,
    ALLOW_UNKNOWN_PROTOCOLS: false,
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'class'],
    USE_PROFILES: { html: true },
    WHOLE_DOCUMENT: false,
    ALLOWED_STYLE_PROP: ['color']
}

const ChatMsg = (props) => {
    const [t] = useTranslation('common')
    const [isMsgOnEditState, setIsMsgOnEditState] = useState(false)
    const [editMsgTextState, setEditMsgTextState] = useState('')

    let msgText = props.msg


    if (msgText && msgText.includes('=>לקוח:')) {
        msgText = msgText.split('=>')
        msgText.splice(0, 1)
        msgText = msgText.map(el => {
            if (el.startsWith('לקוח:')) {
                return '<p style="background-color: rgb(200 226 243); margin:0!important;border-radius:7px;"><i class="fa-solid fa-user-group"></i> ' + el + '</p>'
            }
            else return '<i class="fa-solid fa-robot"></i> ' + el
        }).join('')
    }
    const handleOnEditClicked = useCallback(() => {
        if (!isMsgOnEditState) {//state changed to edit
            setEditMsgTextState(msgText)
        }
        setIsMsgOnEditState(!isMsgOnEditState)

    }, [msgText, setEditMsgTextState, setIsMsgOnEditState, isMsgOnEditState])

    const handleOnMsgUpdateClicked = useCallback((msgId, newMsgText) => {
        setIsMsgOnEditState(false)
        setEditMsgTextState('')
        UpdateMsgById(msgId, newMsgText)
    }, [])

    const hiddeClickHandler = () => {
        const sendObj = {}
        sendObj.msgId = props.msgObj.msgId
        sendObj.isHidden = !props.msgObj.isHidden

        patchMsgById(props.msgObj._id, sendObj).catch((e) => {
            console.log(e)
        })
    }

    const onKeyBoardClick = useCallback((event, action, opt) => {//editMsgTextInput
        if (action === 'editMsgTextInput') {
            if (event.keyCode === 13) {
                // event.preventDefault();
                handleOnMsgUpdateClicked(opt.msgId, opt.editMsgTextState)
            }
        }
    }, [handleOnMsgUpdateClicked])

    //@@@@@@@@@message status@@@@@@@@@@
    let readStatus = null;
    if (props.readStatus === 0) {
        readStatus = null
    }
    if (props.readStatus === 1) {
        readStatus = 'msgNotRecived1'

    }
    else if (props.readStatus === 2) {
        readStatus = 'msgRecived2'
    }
    else if (props.readStatus === 3) {
        readStatus = 'msgread3'
    }
    else if (props.readStatus === 4) {
        readStatus = 'statusFail4'
    }

    //@@@@@@@@@@Client real name@@@@@@@@@@
    let contactName = props.senderName.replace('+972', '0');
    if (props.selectedChatCrmContact && props.selectedChatCrmContact.name) contactName = props.selectedChatCrmContact.name
    else if (props.contact && typeof props.contact === 'object') contactName = props.contact.fullName
    else if (props.displayName) contactName = props.displayName

    //@@@@@@@@@@attach file@@@@@@@@@@
    let file = null
    if (props.file && props.file[0]) {
        file = props.file.map(file => {
            return <ChatMsgFile key={file._id} fileId={file} mediaTokenData={props.mediaTokenData}/>
        }
        )

        // }
        // console.log(file)
    }

    //@@@@@@@@@add reply@@@@@@@@@@
    let replyToMsgDiv = undefined
    if (props.replyToMsg && props.replyToMsg.msg &&
        props.selectedChannel !== 'mail' &&
        (props.replyToMsg.clientName !== props.replyToMsg.msgId)) {
        let replierName = undefined
        if (props.replyToMsg.isAgent) {
            replierName = props.replyToMsg?.userId?.name ? props.replyToMsg.userId.name : props.replyToMsg.agentName
        }
        else {
            if (props.replyToMsg.displayName) {
                replierName = props.replyToMsg.displayName
            }
            else {
                replierName = contactName
            }

        }

        replyToMsgDiv = <div className='replyToMsgDiv'>
            <div className='ReplyHeader'>
                <span className='replyToName'>{replierName}</span>
            </div>
            <div className='ReplyBody'>
                <span className='ReplyMsg'>{props.replyToMsg.msg}</span>
            </div>
        </div>
    }



    let myMsg = null

    let selectedMsgContainerStyle = {}
    let selectedMsgReplyBtnStyle = {}
    let selectedMsgReplyAllBtnStyle = {}
    let selectedMsgForwardToOtherChannelBtnStyle = {}
    let selectedMsgForwardBtnStyle = {}
    let msgActionsDivStyle = {}
    if (props.selectedMsg && props.msgId === props.selectedMsg._id) {
        selectedMsgContainerStyle = { 'border': '3px inset #9dc53b' }
        if (props.selectedMsgAction === 'REPLY') {
            msgActionsDivStyle = { 'display': 'inline-block' }
            selectedMsgReplyBtnStyle = { 'color': 'red' }
        }
        else if (props.selectedMsgAction === 'FORWARD') {
            msgActionsDivStyle = { 'display': 'inline-block' }
            selectedMsgForwardBtnStyle = { 'color': 'red' }
        }
        else if (props.selectedMsgAction === 'REPLY_ALL') {
            msgActionsDivStyle = { 'display': 'inline-block' }
            selectedMsgReplyAllBtnStyle = { 'color': 'red' }
        }
        else if (props.selectedMsgAction === 'FORWARD_TO_OTHER_CHANNEL') {
            msgActionsDivStyle = { 'display': 'inline-block' }
            selectedMsgForwardToOtherChannelBtnStyle = { 'color': 'red' }
        }
    }

    if (props.selectedChannel === 'company') {
        myMsg = props.loggedNowAgent === props.msgObj?.agentName ?
            (
                <div className='d-flex justify-content-end mb-4'>
                    <div className='msg_cotainer_send' style={selectedMsgContainerStyle}>
                        {/* <p className='msgSender'>
                            {props.readStatus === 0 ? null : <i className={"fas fa-thumbs-up msgread " + readStatus}></i>}
                            {props.senderName}</p> */}
                        <div className='msgHead' style={{ 'textAlign': 'right' }}>
                            <div className='msgActionsContainer'>
                                <div className='msgActions' style={{ ...{ 'marginRight': '5px' }, ...msgActionsDivStyle }}>
                                    <i className="fas fa-reply msgReply" title={t('Reply')} style={selectedMsgReplyBtnStyle} onClick={props.onReplyActionSelected} />
                                </div>
                            </div>
                            <p className='msgSender'>
                                {props.readStatus === 0 ? null : <i className={"fas fa-thumbs-up msgread " + readStatus}></i>}
                                {props.senderName}
                            </p>
                        </div>
                        {replyToMsgDiv}
                        <p className={`msgText`}>{props.msg}</p>
                        {file}
                        <p className='msgDate'><span className='msg_time_send'>{props.time}</span></p>
                    </div>
                    <div className='img_cont_msg'>
                        {
                            props.avatarImgElement ? props.avatarImgElement :
                                <img alt='Cant load img' src={userIcon} onError={(event) => { event.target.onerror = null; event.target.src = userIcon }} className='rounded-circle user_img_msg' />
                        }
                    </div>
                </div>
            ) :
            (

                <div className='d-flex justify-content-start mb-4'>
                    <div className='img_cont_msg'>
                        {
                            props.avatarImgElement ? props.avatarImgElement :
                                <img alt='Cant load img' src={userIcon} onError={(event) => { event.target.onerror = null; event.target.src = userIcon }} className='rounded-circle user_img_msg' />
                        }
                    </div>
                    <div className='msg_cotainer' style={selectedMsgContainerStyle}>
                        {/* <p className='msgSender'>{props.readStatus === 0 ? null : <i className={"fas fa-thumbs-up msgread " + readStatus}></i>}{props.senderName}</p> */}
                        <div className='msgHead' style={{ 'textAlign': 'left' }}>
                            <p className='msgSender'>{contactName}</p>
                            <div className='msgActionsContainer'>
                                <div className='msgActions' style={{ ...{ 'marginLeft': '5px' }, ...msgActionsDivStyle }}>
                                    <i className="fas fa-reply msgReply" title={t('Reply')} style={selectedMsgReplyBtnStyle} onClick={props.onReplyActionSelected} />
                                </div>
                            </div>
                        </div>
                        {replyToMsgDiv}
                        <p className={`msgText`}>{props.msg}</p>
                        {file}
                        <p className='msgDate'><span className='msg_time'>{props.time}</span></p>
                    </div>
                </div>
            )
    }
    else {
        //Agent side
        myMsg = props.msgStyle === 'regular' && props.isAgent ?
            (
                <div className='d-flex justify-content-end mb-4'>
                    <div className='msg_cotainer_send' style={selectedMsgContainerStyle}>
                        <div className='msgHead' style={{ 'textAlign': 'right' }}>
                            <div className='msgActionsContainer'>
                                <div className='msgActions' style={{ ...{ 'marginRight': '5px' }, ...msgActionsDivStyle }}>
                                    <i className="fas fa-reply msgReply" title={t('Reply')} style={selectedMsgReplyBtnStyle} onClick={props.onReplyActionSelected} />
                                    {props.selectedChannel === 'mail' ?
                                        <Fragment>
                                            <i title={t('Reply all')} style={selectedMsgReplyAllBtnStyle} onClick={props.onReplyAllActionSelected} className="fas fa-reply-all msgForward" />
                                            <i title={t('Transfer')} style={selectedMsgForwardBtnStyle} onClick={props.onForwardActionSelected} className="fas fa-chevron-right msgForward" />
                                        </Fragment> :
                                        (props.selectedChannel === 'facebook' || props.selectedChannel === 'ig_media' || props.selectedChannel === 'youtube') &&
                                        <Fragment>
                                            {
                                                props.msgObj.clientName !== props.msgObj.msgId &&
                                                <i className='fas fa-trash msgDelete' title={t('remove')} onClick={() => deleteMsgById(props.msgObj.msgId)} />
                                            }
                                            {
                                                (props.selectedChannel === 'facebook' || (props.selectedChannel === 'youtube' && props.msgObj.clientName !== props.msgObj.msgId))
                                                &&
                                                <i className="fa-solid fa-file-pen msgEdit" onClick={handleOnEditClicked} title={t('Edit')} />
                                            }
                                            {
                                                (props.selectedChannel === 'facebook') && props.msgObj.clientName !== props.msgObj.msgId &&
                                                <i onClick={hiddeClickHandler} className={`fa-sharp fa-solid ${!props.msgObj.isHidden ? 'fa-eye-slash' : 'fa-eye'} msgEdit`} />
                                            }
                                        </Fragment>
                                    }
                                </div>
                            </div>
                            <p className='msgSender'>
                                {props.readStatus === 0 ? null : <i className={"fas fa-thumbs-up msgread " + readStatus}></i>}
                                {props.senderName}
                            </p>
                        </div>
                        {props.msgSubject !== undefined && props.msgSubject !== '' ? <p className='msgTitlesRight'>{props.msgSubject}<b> :Subject</b></p> : null}
                        {props.msgMails !== undefined && props.msgMails[0] !== undefined ? <p className='msgTitlesRight'>{props.msgMails.map(mail => mail.name + '<' + mail.address + '> ' + mail.name)}<b> :To</b></p> : null}
                        {props.msgCC !== undefined && props.msgCC[0] !== undefined ? <p className='msgTitlesRight'>{props.msgCC.map(mail => mail.name + '<' + mail.address + '> ')}<b> :CC</b></p> : null}
                        {props.msgBCC !== undefined && props.msgBCC[0] !== undefined ? <p className='msgTitlesRight'>{props.msgBCC.map(mail => mail.name + '<' + mail.address + '> ')}<b> :Bcc</b></p> : null}
                        {props.selectedChannel === 'mail' ? <div className='smallBr' /> : null}
                        {replyToMsgDiv}
                        {
                            props.selectedChannel === 'mail' ? <p className='msgTextMail' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.msg, domPurifyOptionsObj) }}></p>
                                : isMsgOnEditState ?
                                    <div className='editMsgSection'>
                                        <div className='editAcceptBtnDiv'>
                                            <i className="fa-solid fa-circle-check editAcceptBtn" onClick={() => handleOnMsgUpdateClicked(props.msgObj.msgId, editMsgTextState)} />
                                        </div>
                                        <textarea type='textarea' onKeyDown={(e) => onKeyBoardClick(e, 'editMsgTextInput', { msgId: props.msgObj.msgId, editMsgTextState: editMsgTextState })} className='editMsgTextInput' onChange={(e) => { setEditMsgTextState(e.target.value) }} value={editMsgTextState} />
                                    </div>

                                    :
                                    (
                                        <p className={`msgText ${props.msgObj.isHidden && 'msg-text--hide'}`} dangerouslySetInnerHTML={{ __html: msgText }}></p>
                                    )
                        }
                        {file}
                        <p className='msgDate'><span className='msg_time_send'>{props.time}</span></p>
                    </div>
                    <div className='img_cont_msg'>
                        {
                            props.avatarImgElement ? props.avatarImgElement :
                                <img alt='Cant load img' src={userIcon} onError={(event) => { event.target.onerror = null; event.target.src = userIcon }} className='rounded-circle user_img_msg' />
                        }
                    </div>
                </div>
            )
            //Customer side
            : props.msgStyle === 'regular' && !props.isAgent ? (
                <div className='d-flex justify-content-start mb-4'>
                    <div className='img_cont_msg'>
                        <img alt='Cant load img' src={clientIcon} className='rounded-circle user_img_msg' />
                    </div>
                    <div className='msg_cotainer' style={selectedMsgContainerStyle}>
                        <div className='msgHead' style={{ 'textAlign': 'left' }}>
                            <p className='msgSender'>{contactName}</p>
                            <div className='msgActionsContainer'>
                                <div className='msgActions' style={{ ...{ 'marginLeft': '5px' }, ...msgActionsDivStyle }}>
                                    <i className="fas fa-reply msgReply" title={t('Reply')} style={selectedMsgReplyBtnStyle} onClick={props.onReplyActionSelected} />
                                    {props.selectedChannel === 'mail' ?
                                        <Fragment>
                                            <i title={t('Reply all')} style={selectedMsgReplyAllBtnStyle} onClick={props.onReplyAllActionSelected} className="fas fa-reply-all msgForward" />
                                            <i title={t('Transfer')} style={selectedMsgForwardBtnStyle} onClick={props.onForwardActionSelected} className="fas fa-chevron-right msgForward" />
                                        </Fragment> :
                                        (props.selectedChannel === 'facebook' || props.selectedChannel === 'ig_media' || props.selectedChannel === 'youtube') &&
                                        <Fragment>
                                            {/* {
                                                props.selectedChannel === 'youtube' && props.msgObj.clientName !== props.msgObj.msgId &&
                                                <i className='fas fa-trash msgDelete' title={t('remove')} onClick={() => deleteMsgById(props.msgObj.msgId)} />
                                            } */}
                                            {
                                                (props.selectedChannel === 'facebook') && props.msgObj.clientName !== props.msgObj.msgId &&
                                                <i onClick={hiddeClickHandler} className={`fa-sharp fa-solid ${!props.msgObj.isHidden ? 'fa-eye-slash' : 'fa-eye'} msgEdit`} />
                                            }
                                            {
                                                (props.selectedChannel === 'facebook') && props.msgObj?.fromId &&
                                                <i onClick={() => props.onForwardToOtherChannelSelected(props.msgObj.fromId, 'messenger')} style={selectedMsgForwardToOtherChannelBtnStyle} className="fab fa-facebook-messenger msgEdit" />
                                            }
                                        </Fragment>
                                    }
                                </div>
                            </div>
                        </div>
                        {props.msgSubject !== undefined && props.msgSubject !== '' ? <p className='msgTitles'><b>Subject: </b>{props.msgSubject}</p> : null}
                        {props.msgMails !== undefined && props.msgMails[0] !== undefined ? <p className='msgTitles'><b>To: </b>{props.msgMails.map(mail => mail.name + '<' + mail.address + '> ' + mail.name)}</p> : null}
                        {props.msgCC !== undefined && props.msgCC[0] !== undefined ? <p className='msgTitles'><b>CC: </b>{props.msgCC.map(mail => mail.name + '<' + mail.address + '> ')}</p> : null}
                        {props.msgBCC !== undefined && props.msgBCC[0] !== undefined ? <p className='msgTitles'><b>Bcc: </b>{props.msgBCC.map(mail => mail.name + '<' + mail.address + '> ')}</p> : null}
                        {props.selectedChannel === 'mail' ? <div className='smallBr' /> : null}
                        {replyToMsgDiv}
                        {props.selectedChannel === 'mail' ? <p className='msgTextMail' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.msg, domPurifyOptionsObj) }}></p>
                            :
                            <p className={`msgText ${props.msgObj.isHidden && 'msg-text--hide'}`} dangerouslySetInnerHTML={{ __html: removeSpecialChars(msgText) }}></p>}
                        {/* <p className={`msgText ${props.msgObj.isHidden && 'msg-text--hide'}`} dangerouslySetInnerHTML={{ __html: msgText }}></p>} */}
                        {file}
                        <p className='msgDate'><span className='msg_time'>{props.time}</span></p>
                    </div>
                </div>
            )
                : props.msgStyle === 'note' && (
                    <div className='note-container'>
                        {
                            props.avatarImgElement ? props.avatarImgElement :
                                <img alt='Cant load img' src={userIcon} onError={(event) => { event.target.onerror = null; event.target.src = userIcon }} className='rounded-circle user_img_msg' />
                        }
                        <div className='note-msg-container'>

                            <h2 className='note-msg-client-name'>{props.senderName}</h2>
                            <p className='msgText note-msg-body' dangerouslySetInnerHTML={{ __html: msgText }}></p>
                            <p className='msgDate note-msg-time'><time className='msg_time'>{props.time}</time></p>
                        </div>

                    </div>
                )
    }
    return (
        <Fragment>
            {
                props.isLastMsg && props.areMoreMsgToLoad &&
                <div className='topMsgsSection' onClick={props.onFetchMoreChatMsgsClicked}>
                    <i className="fas fa-arrow-alt-circle-up fetchMoreMsgsArrow" />
                </div>
            }
            {myMsg}
        </Fragment>
    );
};

export default ChatMsg;

// style={{ 'textAlign': 'left' }}